<template>
  <v-row>
    <v-col cols="12" sm="12">
      <v-row>
        <v-col
            class="d-flex align-center justify-center"
            cols="12"
            sm="1"
            v-if="type === 'child'"
        >
          <div class="item-counter">
            {{ index }}
          </div>
        </v-col>
        <v-col cols="12" sm="1" v-else />
        <v-col cols="12" sm="11">
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                  v-model="person.name"
                  :rules="emptyRules"
                  label="Full Name"
                  required
              />
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select
                  :rules="emptyRules"
                  v-model="person.gender"
                  :items="baseData.gender"
                  item-text="name"
                  item-value="code"
                  menu-props="auto"
                  label="Gender"
                  required
              />
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-select
                  v-model="person.height"
                  :items="baseData.heights"
                  item-text="text"
                  item-value="value"
                  menu-props="auto"
                  label="Height"
              />
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-text-field
                  v-mask="'###'"
                  v-model="person.weight"
                  label="Pounds"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                  validate-on-blur
                  v-mask="'####-##-##'"
                  v-model="person.birth_date"
                  label="Birth date"
                  placeholder="YYYY-MM-DD"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <div class="quote-details d-flex align-center">
                <p class="toggle-text">Tobacco</p>
                <div class="button r button-1">
                  <input
                      v-model="person.tobacco"
                      :true-value="1"
                      :false-value="0"
                      type="checkbox"
                      class="checkbox"
                      required
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ChildrenSpouseForm",
  props: {
    person: Object,
    emptyRules: Array,
    baseData: Object,
    index: Number,
    type: String,
  },
}
</script>

<style scoped>
  .item-counter {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: lightgray;
    color: white;
    font-size: 18px;
  }
</style>